const intro = (
  <p>
    <strong>Publikacje</strong> to kluczowy element w rozwoju każdego
    specjalisty medycznego. Nasza baza publikacji pozwala na szybkie i skuteczne
    odnalezienie rzetelnych artykułów, badań oraz analiz z dziedziny medycyny.
    Dzięki precyzyjnie dobranym kategoriom i intuicyjnej funkcjonalności
    użytkownik może znaleźć interesujące go treści w kilka sekund.
  </p>
);

const content = (
  <>
    <p>
      <strong>Publikacje medyczne</strong> to specjalistyczne materiały, które
      dostarczają informacji o najnowszych badaniach, terapiach oraz innowacjach
      w świecie medycyny. Każda publikacja zawiera rzetelne dane, oparte na
      badaniach naukowych oraz opiniach ekspertów. Nasza platforma umożliwia
      lekarzom, studentom oraz pasjonatom zdrowia dostęp do wiarygodnych źródeł
      informacji.
    </p>

    <p>Publikacje mogą obejmować szeroki zakres tematów, takich jak:</p>
    <ul>
      <li>
        <strong>Wiadomości</strong> – bieżące wydarzenia i zmiany w systemie
        ochrony zdrowia,
      </li>
      <li>
        <strong>Opinie ekspertów</strong> – analizy i komentarze liderów branży,
      </li>
      <li>
        <strong>Wywiady</strong> – rozmowy z ekspertami i liderami branży
        medycznej,
      </li>
      <li>
        <strong>Raporty</strong> – kompleksowe zestawienia danych,
      </li>
      <li>
        <strong>Praktyka kliniczna</strong> – wskazówki i przypadki medyczne,
      </li>
      <li>
        <strong>Wywiady</strong> – rozmowy z ekspertami i liderami branży
        medycznej,
      </li>
      <li>
        <strong>Ciekawostki</strong> – innowacyjne podejścia i nowinki
        technologiczne,
      </li>
      <li>
        <strong>Recenzje</strong> – analizy publikacji, badań oraz treści
        związanych z medycyną, w tym książek, filmów i aplikacji edukacyjnych.
      </li>
    </ul>

    <p>
      Aby znaleźć interesującą publikację, wystarczy wprowadzić temat lub słowo
      kluczowe w pole wyszukiwania. Dzięki zaawansowanym algorytmom system
      dopasuje najlepsze wyniki do Twoich potrzeb.
    </p>

    <h3>Najpopularniejsze kategorie publikacji medycznych</h3>
    <p>
      Na naszej platformie dostępne są tysiące unikalnych publikacji, które
      podzieliliśmy na kluczowe kategorie:
    </p>
    <ul>
      <li>
        <strong>Wiadomości</strong> – bieżące wydarzenia i zmiany w systemie
        ochrony zdrowia,
      </li>
      <li>
        <strong>Opinie ekspertów</strong> – analizy i komentarze liderów branży,
      </li>
      <li>
        <strong>Wywiady</strong> – rozmowy z ekspertami i liderami branży
        medycznej,
      </li>
      <li>
        <strong>Raporty</strong> – kompleksowe zestawienia danych,
      </li>
      <li>
        <strong>Praktyka kliniczna</strong> – wskazówki i przypadki medyczne,
      </li>
      <li>
        <strong>Wywiady</strong> – rozmowy z ekspertami i liderami branży
        medycznej,
      </li>
      <li>
        <strong>Ciekawostki</strong> – innowacyjne podejścia i nowinki
        technologiczne,
      </li>
      <li>
        <strong>Recenzje</strong> – analizy publikacji, badań oraz treści
        związanych z medycyną, w tym książek, filmów i aplikacji edukacyjnych.
      </li>
    </ul>
    <p>
      Znajomość najpopularniejszych publikacji medycznych oraz regularne
      korzystanie z naszej bazy wiedzy to klucz do sukcesu w dynamicznie
      rozwijającej się branży ochrony zdrowia.
    </p>

    <h3>Wiadomości</h3>
    <p>
      Wiadomości medyczne to serce dynamicznie zmieniającego się świata ochrony
      zdrowia. Codziennie pojawiają się nowe regulacje, odkrycia naukowe oraz
      doniesienia o przełomach w diagnostyce i terapii. Dzięki tej sekcji masz
      pewność, że nic istotnego Cię nie ominie.
    </p>

    <p>
      W sekcji Wiadomości znajdziesz aktualne informacje o zmianach w prawie
      medycznym, decyzjach Ministerstwa Zdrowia, przełomowych badaniach oraz
      najnowszych technologiach wspierających diagnostykę i leczenie.
      Analizujemy również ekonomiczne aspekty ochrony zdrowia, wynagrodzenia
      pracowników medycznych oraz wpływ globalnych wydarzeń na polski system
      zdrowotny.
    </p>
  </>
);

export const publicationDescription = { intro, content };
